import React from "react";

type PropsType = {
  color?: string;
  style?: React.CSSProperties;
  size?: number;
};

const EssentialsPricing = ({ size = 61, style = {} }: PropsType) => {
  return (
    <svg
      width={size}
      height={(size / 61) * 60}
      style={style}
      viewBox="0 0 61 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.6877 17.8833C29.4059 16.3444 31.5941 16.3444 32.3123 17.8833L35.2836 24.2499C35.4823 24.6755 35.8245 25.0177 36.2501 25.2164L42.6167 28.1877C44.1556 28.9059 44.1556 31.0941 42.6167 31.8123L36.2501 34.7836C35.8245 34.9823 35.4823 35.3245 35.2836 35.7501L32.3123 42.1167C31.5941 43.6556 29.4059 43.6556 28.6877 42.1167L25.7164 35.7501C25.5177 35.3245 25.1755 34.9823 24.7499 34.7836L18.3833 31.8123C16.8444 31.0941 16.8444 28.9059 18.3833 28.1877L24.7499 25.2164C25.1755 25.0177 25.5177 24.6755 25.7164 24.2499L28.6877 17.8833Z"
        fill="url(#paint0_radial_107_42940)"
        stroke="#003125"
        stroke-width="4"
      />
      <defs>
        <radialGradient
          id="paint0_radial_107_42940"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(43.0423 17.458) rotate(133.959) scale(31.4758 16.184)"
        >
          <stop stop-color="#EF89E4" />
          <stop offset="0.34862" stop-color="#BC5BEB" />
          <stop offset="0.584507" stop-color="#EF89E4" />
          <stop offset="0.965" stop-color="#BC5BEB" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default EssentialsPricing;
